module.exports = __webpack_public_path__ + "img/motorway_8x4_z18.22b17bf2.svg";